import { episodeOfCareAction } from './constant';

const {
  CREATE_EPISODE_OF_CARE_REQUEST,
  EDIT_EPISODE_OF_CARE_REQUEST,
  GET_EPISODE_OF_CARE_REQUEST,
  RESET_CREATE_EPISODE_OF_CARE,
  RESET_EDIT_EPISODE_OF_CARE,
  GET_SINGLE_EPISODE_OF_CARE_REQUEST,
  GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_REQUEST,
  ClOSE_EPISODE_OF_CARE_REQUEST,
  RESET_CLOSE_EPISODE_OF_CARE,
} = episodeOfCareAction;

export const getEpisodeOfCare = (payload: object) => {
  return {
    type: GET_EPISODE_OF_CARE_REQUEST,
    payload,
  };
};
export const closeEpisodeOfCare = (payload: object) => {

  return {
    type: ClOSE_EPISODE_OF_CARE_REQUEST,
    payload,
  };
};
export const resetCloseEpisodeOfCare = () => {
  return {
    type: RESET_CLOSE_EPISODE_OF_CARE,
  };
};

export const getSingleEpisodeOfCare = (payload: object) => {
  return {
    type: GET_SINGLE_EPISODE_OF_CARE_REQUEST,
    payload,
  };
};

export const createEpisodeOfCare = (payload: object) => {
  return {
    type: CREATE_EPISODE_OF_CARE_REQUEST,
    payload,
  };
};

export const resetCreateEpisodeOfCare = () => {
  return {
    type: RESET_CREATE_EPISODE_OF_CARE,
  };
};

export const editEpisodeOfCare = (payload: any) => {
  return {
    type: EDIT_EPISODE_OF_CARE_REQUEST,
    payload,
  };
};

export const resetEditEpisodeOfCare = () => {
  return {
    type: RESET_EDIT_EPISODE_OF_CARE,
  };
};

export const getEpisodeOfCareRequiredDocument = (payload: object) => {
  return {
    type: GET_EPISODE_OF_CARE_REQUIRED_DOCUMENT_REQUEST,
    payload,
  };
};